import component from './DestinationSelectorModal';

export default component;
